/**
 * /* eslint-disable no-restricted-globals
 *
 * @format
 */

import isBrowser from "./is-browser";

export default function thirdPartyLogin(href) {
  if (!isBrowser) return null;
  // eslint-disable-next-line no-restricted-globals
  const loginWindow = open(href, "_self");
  return new Promise()((res, rej) => {
    function listen(e) {
      const { origin, data } = e;
      if (
        [
          "https://whatsapp-business.infomedia.co.id",
          "http://localhost:3011",
        ].includes(origin) === false
      )
        return;

      if (typeof data != "string") return;
      const escaped = (() => {
        const txt = document.createElement("textarea");
        txt.innerHTML = data;
        return txt.value;
      })();

      try {
        const rawUser = JSON.parse(escaped);
        if (rawUser == null) throw new Error("User data is empty!");

        if (rawUser.token == null) {
          throw new Error("Token is empty!");
        }

        return res(rawUser);
      } catch (e) {
        return;
      }
    }

    window.addEventListener("message", listen);
  }).finally(() => {
    loginWindow?.close();
  });
}
